export default __webpack_public_path__ + "static/media/4 - Cosmic Lotus.e5374c19.jpg";